import {gql} from "@apollo/client";
import filterDataGql, {executeQueryUtil} from "../utils/gqlUtil";
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  name
  pivotModelContent
  usePivot
  title
  chartCategoryId
  mdDescription
  height
  mediaUrl
  chartCategoryId
`

export const getDataGridImplementationsQuery = () => {

  return gql`
    query {
      getDataGridImplementations {
        ${common}
      }
    }
  `;
}

export const getDataGridImplementationQuery = (dataGridImplementationId) => {

    return gql`
    query {
      getDataGridImplementation(dataGridImplementationId: "${dataGridImplementationId}") {
        ${common}
      }
    }
  `;
}

export const createDataGridImplementationMutation = (data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        [] );
    return gql`mutation {
      addDataGridImplementation(data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const updateDataGridImplementationMutation = (data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        ["groupBy"] );
    return gql`mutation {
      updateDataGridImplementation(data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const bulkDeleteDataGridImplementationMutation = (ids) => {
    var idsString =  JSON.stringify(ids);

    return gql`
    mutation {
      bulkDeleteDataGridImplementation(dataGridImplementationIds: ${idsString}) {
        ids
      }
    }
  `;
}

export const addDataDataGridImplementationToCache = async (datas) => {
    if (!datas) {
        return
    }
    const query = getDataGridImplementationsQuery();
    const data = await executeQueryUtil(query);

    if (data) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getDataGridImplementations: [...data.data.getDataGridImplementations, ...datas]
            },
        });
    }
}

export const deleteDataGridImplementationFromCache = async (ids) => {
    const query = getDataGridImplementationsQuery();
    const res = await executeQueryUtil(query);
    const newData = res.data.getDataGridImplementations.filter(item =>
        !ids.includes(item.id)
    )

    if (res) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getDataGridImplementations: [...newData]
            },
        });
    }
}






